import { Controller, useFormContext } from 'react-hook-form'

import { DatePicker, FF2 } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const Date = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`suspiciousActivityInfo.ipAddresses.${index as 0}.date`}
      control={control}
      render={({ field }) => <FF2 label="Date" field={field} input={(props) => <DatePicker {...props} />} />}
    />
  )
}
